import React, { Component } from 'react';

import {
    Row, Col, Radio, Button,
} from 'antd';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class CustomMonth extends Component {
    state = {
        type: 1,
        week_no: '',
        day: '',
        date: '',
    }


    onChange = (event) => {
        this.setState({ type: event.target.value });
    }

    onWeekChange = (event) => {
        this.setState({ week_no: event.target.value });
    }

    onDayChange = (event) => {
        this.setState({ day: event.target.value });
    }

    onDateChange = (event) => {
        this.setState({ date: event.target.value });
    }

    handleFinal = () => {
        const { handleDoseFrequency, changeActiveKey } = this.props;
        const {
            type, week_no, date, day,
        } = this.state;

        let state;
        if (type === 1) {
            const frequency = 30;
            state = { frequency, month_day_occurrence: week_no, day_num: day };
        } else if (type === 2) {
            const frequency = 0;
            const month_days = `${date}#`;
            state = { frequency, month_days };
        }

        handleDoseFrequency(state);
        changeActiveKey('4');
    }


    render() {
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            bottomTop: '10%',
        };

        const { data, changeActiveKey } = this.props;

        const { type, day, date } = this.state;

        const { month_day_occurrence, day_num } = data;

        const days = [
            { key: 1, value: 'M' },
            { key: 2, value: 'T' },
            { key: 3, value: 'W' },
            { key: 4, value: 'TH' },
            { key: 5, value: 'F' },
            { key: 6, value: 'S' },
            { key: 0, value: 'SU' },
        ];
        const dates = [
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15',
            '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
            '30', '31',
        ];

        const dayRadio = days.map(d => (
            <Col span={3} style={{ padding: '5px' }}>
                <Radio key={d.key} value={d.key}>{d.value}</Radio>
            </Col>
        ));

        const dateRadio = dates.map(d => (
            <Col span={3} style={{ padding: '5px' }}>
                <Radio key={d} value={d}>{d}</Radio>
            </Col>
        ));

        return (
            <div>
                <Row type="flex" justify="space-around">
                    <Col span={8}>
                        <div style={{ verticalAlign: 'center', marginTop: '30%' }}>
                            <RadioGroup onChange={this.onChange} value={type}>
                                <Radio style={radioStyle} value={1}>By Day</Radio>
                                <Radio style={radioStyle} value={2}>By Date</Radio>
                            </RadioGroup>
                        </div>
                    </Col>

                    <Col span={15}>
                        <div>
                            <div style={{ marginBottom: '20px' }}>
                                <RadioGroup
                                    defaultValue={day_num == null
                                        ? ''
                                        : day_num}
                                    disabled={type !== 1}
                                    onChange={this.onWeekChange}
                                    size="big"
                                >
                                    <RadioButton value={1}>1st Week</RadioButton>
                                    <RadioButton value={2}>2nd Week</RadioButton>
                                    <RadioButton value={3}>3rd Week</RadioButton>
                                    <RadioButton value={4}>4th Week</RadioButton>
                                </RadioGroup>
                            </div>
                            <div>
                                <RadioGroup
                                    defaultValue={month_day_occurrence == null
                                        ? ''
                                        : month_day_occurrence}
                                    disabled={type !== 1}
                                    onChange={this.onDayChange}
                                    value={day}
                                >
                                    <Row style={{ paddingLeft: '50px' }}>
                                        { dayRadio }
                                    </Row>
                                </RadioGroup>
                            </div>
                            <div style={{ marginTop: '40px' }}>
                                <RadioGroup disabled={type !== 2} onChange={this.onDateChange} value={date}>
                                    <Row>
                                        { dateRadio }
                                    </Row>
                                </RadioGroup>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row type="flex" justify="center" style={{ marginTop: '5%' }}>
                    <Col span={12}>
                        <Button type="primary" onClick={() => changeActiveKey('2')}>To Prev</Button>
                    </Col>

                    <Col span={12}>
                        <Button type="primary" onClick={this.handleFinal}>To Next</Button>
                    </Col>
                </Row>

            </div>
        );
    }
}

export default CustomMonth;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/DoseFrequencyHelper/CustomMonth.js